module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTH6Pn4SNnYONnYONnYONnoWLn4ONnYePn4SNnYOMnYWNnYONn4OLnYWNn6EhhQMAAAAOdFJOUwAQ4FLRgDPwIKCwcMGRpPPcSAAAAGhJREFUCNdj4Fg3gQECzN89hrL83j0XgLDevXtngM7ye/caqu7eOwUoKw/O4oGbwgE3hSHunSOUxfXuUQJDuhqQxej37mmH3ruFQKbMOxB4ApKfB2I9B7GY9YCsp2BNokAm1AC22NkCABLvL7vLxq4WAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-popver-phone.png
// module id = JaWo
// module chunks = 34